"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var atLeast = exports.atLeast = function atLeast(width) {
  return "@media screen and (min-width: " + width + "px)";
};
var between = exports.between = function between(minWidth, maxWidth) {
  return "@media screen and (min-width: " + minWidth + "px)\nand (max-width: " + (maxWidth - 1) + "px)";
};